import React from 'react';
import ReactDOM from 'react-dom/client';
import classnames from 'classnames/bind';
import styles from './alert.module.scss';

const cx = classnames.bind(styles);

export interface AlertProps {
  title: string;
  desc?: React.ReactNode | string;
  notice?: React.ReactNode;
  dimmed?: boolean;
  onOk?: (e: React.MouseEvent) => void;
  onClickBgClose?: boolean;
}

const Alert = (props: AlertProps) => {
  const el = document.getElementById('alert') as HTMLElement;

  const { title, desc, notice, dimmed, onOk, onClickBgClose } = props;

  const handleOk: React.MouseEventHandler = (e) => {
    handleClose();
    onOk?.(e);
  };

  const handleClose = () => {
    if (root) {
      root.unmount();
    }
  };

  const handleBgClose = () => onClickBgClose && handleClose();
  const stopPropagation: React.MouseEventHandler = (e) => e.stopPropagation();

  const alert = (
    <div className={cx('alert', dimmed && 'dimmed')} onClick={handleBgClose}>
      <div className={cx('layer')} onClick={stopPropagation}>
        <strong className={cx('title')}>{title}</strong>
        <p className={cx('desc')}>{desc}</p>
        <p className={cx('notice')}>{notice}</p>
        <button onClick={handleOk} className={cx('btnConfirm')} type="button">
          확인
        </button>
      </div>
    </div>
  );

  const root = ReactDOM.createRoot(el);
  root.render(alert);
};

export default Alert;
